import * as React from 'react';
import './locationLabel.module.scss';
import classNames from 'classnames';
import { LaptopChromebookOutlined } from '@material-ui/icons';

const LocationBadgeBase = ({ children, type, upperLabel = undefined, className }) => (
    <div styleName={classNames('badge-wrapper', type)}>
        {upperLabel && <div styleName="upper-label">{upperLabel}</div>}
        <div styleName={classNames('location-badge', type)} className={className}>
            {children}
        </div>
    </div>
);

export const LocationBadge = ({ location, type = 'normal', upperLabel = undefined, className = undefined }) => {
    if (!location) {
        return (
            <LocationBadgeBase className={className} type={type} upperLabel={upperLabel}>
                <LaptopChromebookOutlined styleName="online-icon" />WEB体験
            </LocationBadgeBase>
        );
    }
    return (
        <LocationBadgeBase className={className} type={type} upperLabel={upperLabel}>
            {location.short_name || location.name}
        </LocationBadgeBase>
    );
};
